<template>
  <div class="table-drop w-dropdown">
    <TableRow
      :order="order"
      :tab="tab"
      :additional2="rowAdditional2"
      :additional="rowAdditional"
      :open="open === order.id"
      :hide-price="hidePrice"
      :change-patient-client="changePatientClient"
      @open="$emit('open', order.id)"
    />

    <OrderDetails
      :order="order"
      :tab="tab"
      :class="{'w--open': open === order.id}"
      :hide-price="hidePrice"
      :hide-ready-date="hideReadyDate"
      @open="$emit('open', order.id)"
    />
  </div>
</template>

<script>
  import TableRow from '@/containers/orders/TableRow';
  import OrderDetails from '@/containers/orders/container/OrderDetails';

  export default {
    name: 'TableContainer',
    components: {OrderDetails, TableRow},
    props: {
      open: Number,
      order: {
        type: Object,
        required: true,
      },
      tab: String,
      rowAdditional: String,
      rowAdditional2: String,
      hidePrice: Boolean,
      hideReadyDate: Boolean,
      changePatientClient: Boolean,
    },
  };
</script>
